var _style, _rect, _polygon, _polygon2, _polygon3, _path, _polygon4, _polygon5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInternationalEnglishLanguageTestingSystemIeltsVectorLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "layer",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-153 -46 652 652",
    style: {
      enableBackground: "new -153 -46 652 652"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#DD052B;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -131.8,
    y: 191.7,
    className: "st0",
    width: 42.8,
    height: 166.9
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-71.4,191.7 57.7,191.7 57.7,225.8 -28.7,225.8 -28.7,256.4 57.3,256.4 57.3,289.9 -28.7,289.9  -28.7,324.4 58.1,324.4 58.1,358.5 -71.4,358.5 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "74.1,191.7 117.1,191.7 117.1,322.4 195.5,322.4 195.5,358.5 74.1,358.5 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "211.6,225.5 163.7,225.5 163.7,191.7 302.2,191.7 302.2,225.5 254.2,225.5 254.2,358.6 211.6,358.6 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M345.1,303.1c0.4,19,11.2,28.7,31.6,28.7c17.9,0,27.4-6.3,27.4-16.5c0-5.6-2.5-9.7-6.5-11.9 c-10-5-29-8.3-53.4-18.1c-24.1-9.5-36.6-25.5-36.6-46.1c0-31.4,24.7-52.3,66.6-52.3c40.7,0,65.4,21.8,65.4,55h-40.1 c-1.8-15.5-10.9-22.7-28.1-22.7c-14.4,0-23.3,6.7-23.3,15.1c0,12.5,13,15.1,39.3,23.6c19.3,6.4,33.1,10.7,41.3,17.2 c10.9,8.9,16.4,20.9,16.4,35.3c0,32.6-25.7,52.8-72.6,52.8c-43.5,0-66-19.8-68.5-60.1H345.1"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "437.5,194.6 431.9,194.6 431.9,191.2 446.9,191.2 446.9,194.6 441.4,194.6 441.4,210.1 437.5,210.1 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "449.4,191.2 455.1,191.2 458.8,205.5 462.5,191.2 468.2,191.2 468.2,210.1 464.6,210.1 464.6,194.9 460.8,210.1  456.8,210.1 453,194.9 453,210.1 449.4,210.1 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternationalEnglishLanguageTestingSystemIeltsVectorLogo);
export default __webpack_public_path__ + "static/media/international-english-language-testing-system-ielts-vector-logo.f3879419bd7be2597c88d5dcf1237ffe.svg";
export { ForwardRef as ReactComponent };